import { Model } from "@bryntum/schedulerpro";
import { HasProjectMixin } from "./mixins/HasProjectMixin";

export class KeyValueModel extends HasProjectMixin(Model) {
  static get $name() {
    return "KeyValueModel";
  }

  static get fields() {
    return ["key", "value", "user"];
  }
}

KeyValueModel.exposeProperties();
